// ===========================================
// CENTRALIZED EMAIL CONFIGURATION (Frontend)
// Reads from VITE_ env vars, falls back to defaults
// ===========================================

export const emailConfig = {
  support: import.meta.env.VITE_SUPPORT_EMAIL || 'support@tripnovac.com',
  sales: import.meta.env.VITE_SALES_EMAIL || 'sales@tripnovac.com',
  billing: import.meta.env.VITE_BILLING_EMAIL || 'billing@tripnovac.com',
  partners: import.meta.env.VITE_PARTNERS_EMAIL || 'partners@tripnovac.com',
  noreply: import.meta.env.VITE_NOREPLY_EMAIL || 'noreply@tripnovac.com',
};

export default emailConfig;
